<template>
    <div>
        <div :class="isMobile?'contBoxB':'contBox'">
           <div class="clearfix">
            <span class="fl mr5" :class="isMobile?'ml10':''">当前位置:</span>
            <el-breadcrumb class="fl" style="margin-top: 4px;font-size: 15px;" separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                <el-breadcrumb-item :to="{ path: '/policyRegulate' }">{{title}}</el-breadcrumb-item>
                <el-breadcrumb-item>{{title}}详情</el-breadcrumb-item>
            </el-breadcrumb>
           </div>
           <div :class="isMobile?'contentShowB':'contentShow'">
                <p class="contsTitle" style="border: none;">{{info.Title}}</p>
                <p class="sendTime">发布时间:{{info.AddTime | timeToDate}}</p>
                <div class="contSHow" v-html="info.Content"></div>
           </div>
        </div>
    </div>
</template>

<script>
    export default{
        data(){
            return{
                id:'',
                type:'',
                info:'',
                title:'政策法规'
            }
        },
        methods:{
            getInfo(){
                this.Request({
                    url: '/api/NewsData/GetNewsDataDetail',
                    method: 'get',
                    data:{
                        id:this.id
                    }
                }).then((data) => {
                   this.info = data.Data
                })
            }
        },
        mounted(){
            this.type = this.$route.query.type
            this.id = this.$route.query.id
            this.getInfo()
        }
    }
</script>
